<template>
  <!--    测试账号界面-->

  <div style="min-width: 900px;min-height: 200px;max-height: 400px;overflow: auto">

    <el-table
      :data="accountsListL"
      stripe
      show-overflow-tootip="true"
    >


      <el-table-column  align="center" label="手机号">

      </el-table-column>

      <el-table-column  align="center" label="邮箱">

      </el-table-column>

      <el-table-column  align="center" label="密码">

      </el-table-column>


    </el-table>

  </div>
</template>

<script>
  export default {
    name: 'TestAccount',
    data () {
      return {
        accountsListL: []
      }
    }
  }
</script>

<style scoped>

</style>
